import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import T from 'prop-types';
import { get, isEmpty } from 'lodash-es';

import skeletons from './Skeletons';
import VisibilityScore from './VisibilityScore';
import Button from '../../../../Buttons/Button';
import ErrorStateWithReload from '../../../../ErrorStateWithReload';
import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';

import { permissionsSelector, quickViewDataSelector } from '../../../selectors';
import links from '../../../configs/links';

const Keywords = ({ store, ref_no, settings }) => {
  const data = useSelector(quickViewDataSelector);
  const permissions = useSelector(permissionsSelector);

  const organic = get(data, 'aso.organic', {});
  const showOrganic = !isEmpty(organic);

  const progressBarOrganicData = useMemo(
    () =>
      !isEmpty(organic)
        ? {
            title: 'ASO Visibility Score',
            score: organic.score,
            firstMetric: {
              title: 'Rank',
              value: organic.rank,
            },
            secondaryMetric: {
              title: 'Popularity',
              value: organic.popularity,
            },
          }
        : {},
    [organic]
  );

  const { error } = settings;
  if (error) return <ErrorStateWithReload />;

  return (
    <InsightsCardBox
      headerLeft={<div className="paragraph">Keywords</div>}
      headerRight={
        permissions.allowAso && (
          <Button variant="secondary" size="sm" href={links.organicKeywords(store, ref_no)}>
            Go to Keywords
          </Button>
        )
      }
      bodyMinHeight={130}
      className="aso-section"
    >
      <div className="aso-widget">
        {settings.pending
          ? skeletons.asoScoreProgressBar
          : showOrganic && (
              <VisibilityScore data={progressBarOrganicData} className="only-aso-score" />
            )}
      </div>
    </InsightsCardBox>
  );
};

Keywords.propTypes = {
  store: T.string,
  ref_no: T.oneOfType([T.string, T.number]),
  settings: T.object,
};

export default Keywords;
